import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function PlayButton({ className, ...props }: ButtonProps) {
  return (
    <Button
      size={"icon"}
      variant={"outline"}
      className={cn(
        "flex h-10 w-10 items-center justify-center rounded-full border-[#C6BDA5B2]/70 bg-transparent md:h-14 md:w-14",
        className,
      )}
      {...props}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.6871 9.14501L6.5902 3.02565C5.92376 2.62175 5.0719 3.10157 5.0719 3.88085V16.1196C5.0719 16.8988 5.92376 17.3787 6.5902 16.9748L16.6871 10.8554C17.3294 10.4662 17.3294 9.53426 16.6871 9.14501Z"
          stroke="#C6BDA5"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );
}
